export default {options:{api:'warranty',version:1},children:[{options:{key:'isCovered',type:'value'}}]}